import React from 'react';
import { Popover } from 'antd';
import PropTypes from 'prop-types';

const CustomPopOver = ({ children, TriggerComponent, ...rest }) => {
  return (
    <Popover trigger="click" content={children} {...rest}>
      {TriggerComponent}
    </Popover>
  );
};

CustomPopOver.propTypes = {
  TriggerComponent: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
};

export default CustomPopOver;
